"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundedHoursFormatter = void 0;
const getHoursFromMinutes = (n) => n / 60;
const roundedHoursFormatter = (n) => Math.round(Number(getHoursFromMinutes(n)));
exports.roundedHoursFormatter = roundedHoursFormatter;
//# sourceMappingURL=rounded-hours-formatter.js.map